import { render, staticRenderFns } from "./QuotationAddTaskModal.vue?vue&type=template&id=33f485f3&scoped=true&"
import script from "./QuotationAddTaskModal.vue?vue&type=script&lang=js&"
export * from "./QuotationAddTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f485f3",
  null
  
)

export default component.exports